var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6864 8.10107C14.5773 8.10107 15.0234 9.17822 14.3935 9.80818L8.10067 16.101L1.80786 9.80818C1.17789 9.17822 1.62406 8.10107 2.51496 8.10107H8.10067H13.6864Z",
    fill: "#6150AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99902 13H8.99902V19.1726C8.99902 19.7249 8.55131 20.1726 7.99902 20.1726C7.44674 20.1726 6.99902 19.7249 6.99902 19.1726V13Z",
    fill: "#6150AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAlt);
export default __webpack_public_path__ + "static/media/filter-alt.9977e0caba25ca97ecc8cb51a1cd4e05.svg";
export { ForwardRef as ReactComponent };